import { combineReducers } from 'redux'
import { firestoreReducer } from 'redux-firestore'
import { firebaseReducer } from 'react-redux-firebase'
import memberReducer from '../Reducers/memberReducers/memberReducers'
import authReducer from '../Reducers/authReducers/authReducers'



 const rootReducer = combineReducers({ 
  firestore: firestoreReducer,
  firebase: firebaseReducer,
  memberReducer: memberReducer,
  auth: authReducer,
 })

export default rootReducer